import styled from 'styled-components';

// @ts-nocheck
var Ratings = styled.div.withConfig({
  displayName: "Ratingsstyle__Ratings",
  componentId: "sc-kohz14-0"
})(["display:flex;column-gap:var(--space-500);row-gap:var(--space-200);align-items:center;flex-wrap:wrap;"]);

export { Ratings };
//# sourceMappingURL=Ratings.style.js.map
